import { memo } from 'react';

interface OrderAcceptConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const OrderAcceptConfirmModal = memo(function OrderAcceptConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  loading = false
}: OrderAcceptConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-sm w-full p-6">
        <div className="text-center">
          <div className="mb-4">
            <p className="text-gray-800 leading-relaxed">
              이 주문을 접수하시겠습니까?
            </p>
            <p className="text-gray-800 leading-relaxed mt-2">
              재고가 없을 경우 매장 수락 전에 바로 취소해주셔야 합니다.
            </p>
          </div>
          
          <div className="flex space-x-3">
            <button
              onClick={onClose}
              disabled={loading}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              아니오
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className="flex-1 py-2 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 disabled:opacity-50"
            >
              {loading ? '처리 중...' : '확인'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});
